export const ja = {
  // Header
  home: "ホーム",
  pricing: "料金",
  features: "機能",
  faq: "よくある質問",
  aiGenerator: "AI画像生成",
  login: "ログイン",

  // Hero Section
  heroTitle: "Lunabrush AI",
  heroSubtitle: "数秒で素晴らしいAI生成画像を作成",
  worldFirstFree: "世界初の無制限無料AI画像生成ツール",
  hundredPercentFree: "100%無料",
  poweredByFlux: "Flux19svを搭載",
  noLoginRequired: "ログイン不要",
  unlimitedGeneration: "無制限生成",

  // AI Generator Section
  aiGeneratorTitle: "AI画像生成器",
  freeTrial: "無料トライアル",
  describeImage: "生成したい画像を説明してください...",
  generating: "生成中...",
  generateImage: "画像を生成",
  generatingPlease: "生成中です、しばらくお待ちください......",

  // Gallery Section
  inspiration: "インスピレーションを得る",
  inspirationDesc: "Lunabrush AIが生成した素晴らしい画像を探索",
  viewMore: "もっと見る",

  // Image Gallery
  futuristicCity: "未来都市の夜景、ネオンライト、サイバーパンクスタイル",
  forestCabin: "霧に囲まれた森の中の神秘的な小屋",
  spaceAstronaut: "宇宙の宇宙飛行士、星雲の背景",
  underwaterWorld: "水中世界、サンゴ礁、熱帯魚",
  samurai: "古代日本の侍、舞い散る桜",
  mountainLake: "山の湖、日の出、薄い霧",
  spaceStation: "SFの宇宙ステーション、惑星の背景",
  magicForest: "魔法の森、光るキノコ、妖精",

  // Features
  featuresTitle: "Lunabrushの主な機能",
  featuresDesc: "最高の画像生成体験を提供するため、AIモデルを継続的に改善しています",
  highQuality: "高品質生成",
  highQualityDesc: "最先端のAIモデルを使用して素晴らしい高品質画像を生成",
  fastResponse: "高速レスポンス",
  fastResponseDesc: "数秒でAI生成画像を取得、待機不要",
  privacyProtection: "プライバシー保護",
  privacyProtectionDesc: "プロンプトと生成画像は厳格に保護されます",
  multipleStyles: "複数のスタイル",
  multipleStylesDesc: "リアルからアニメまで、様々なアートスタイルをサポート",
  globalAvailable: "グローバル利用可能",
  globalAvailableDesc: "グローバルサーバー配布により高速アクセスと生成を保証",
  apiAccess: "APIアクセス",
  apiAccessDesc: "エンタープライズグレードのAPIアクセス、アプリケーションに簡単統合",

  // Stats
  statsTitle: "数百万人に信頼されています",
  statsDesc: "グローバルコミュニティに参加し、AI画像生成の無限の可能性を探索",
  registeredUsers: "登録ユーザー",
  dailyImages: "日次生成画像",
  averageRating: "平均評価",
  millionPlus: "300万+",
  dailyCount: "1,530",
  rating: "4.9",

  // Testimonials
  testimonialsTitle: "Lunabrush AIに対するユーザーの声",
  testimonialsDesc: "他のユーザーがLunabrush AIを使用してクリエイティブワークフローを向上させる方法をご覧ください",
  testimonial1Name: "李明",
  testimonial1Role: "UI/UXデザイナー",
  testimonial1Content:
    "Lunabrush AIは私のデザインプロセスを完全に変えました。コンセプト画像を素早く生成でき、多くの時間を節約できます。画像の品質は素晴らしいです！",
  testimonial2Name: "王暁華",
  testimonial2Role: "コンテンツクリエイター",
  testimonial2Content:
    "コンテンツクリエイターとして、毎日多くの画像素材が必要です。Lunabrush AIを使えば、ユニークな画像を簡単に生成でき、作業効率が大幅に向上します。",
  testimonial3Name: "張偉",
  testimonial3Role: "ゲーム開発者",
  testimonial3Content:
    "Lunabrush AIの画像生成能力は非常に強力で、特にゲームコンセプトアートの作成に役立ちます。チームがアイデアを素早く反復し、開発プロセスを加速するのに役立ちます。",

  // FAQ
  faqTitle: "よくある質問",
  faqDesc: "サービスに関する一般的な質問への回答を見つける",
  faq1Question: "なぜLunabrush AIを使うのですか？",
  faq1Answer:
    "Lunabrush AIは最先端のAI画像生成技術を提供し、ユーザーはワンクリックで美しい画像を作成できます！私たちのモデルは複雑なプロンプトを理解し、高品質で詳細な画像を生成するように特別にトレーニングされています。さらに、さまざまなクリエイティブニーズに対応するために、多様なスタイルオプションを提供しています。",
  faq2Question: "サブスクリプションをアップグレードまたはキャンセルできますか？",
  faq2Answer:
    "もちろんです！アカウント設定でいつでもサブスクリプションプランをアップグレードまたはダウングレードできます。サブスクリプションをキャンセルする場合は、アカウントページで簡単に行うことができ、追加料金は発生しません。",
  faq3Question: "返金を受けることはできますか？",
  faq3Answer: "いいえ、返金サービスは提供していません。",
  faq4Question: "私のプロンプトは保存されますか？",
  faq4Answer:
    "はい、サービス向上のためにプロンプトを保存しています。ただし、ユーザーのプライバシーを非常に重視しており、保存されたすべてのプロンプトは匿名化され、個人情報と関連付けられません。有料ユーザーの場合、プライバシーモードを有効にすることができ、プロンプトは保存されません。",
  faq5Question: "Ultimateにサブスクライブすると、より高品質の画像を取得できますか？",
  faq5Answer:
    "はい！Ultimateサブスクリプションユーザーは、より高解像度でより豊かな詳細を持つ画像を生成する高解像度（HD）画像生成機能にアクセスできます。さらに、Ultimateユーザーは、より高品質の画像を生成するために特別に最適化された当社のプロフェッショナルモデルも使用できます。",
  faq6Question: "サブスクライブしても広告は表示されますか？",
  faq6Answer:
    "有料プランにサブスクライブすると、広告は表示されません。有料ユーザーには、創作に集中できるよう、最高の邪魔のない体験を提供したいと考えています。",
  faq7Question: "ユーザーサポートをリクエストできますか？",
  faq7Answer: "はい！技術サポートやサポートについては、support@lunabrush.aiまでメールでお問い合わせください。",
  faq8Question: "エンタープライズレベルのサービスとは何ですか？",
  faq8Answer:
    "特別なソリューションが必要な場合、専用サポート、より高い使用量割り当て、APIアクセスなどを含むエンタープライズレベルのサービスを提供しています。詳細については、sales@lunabrush.aiまでお問い合わせください。",

  // Footer
  footerDesc: "Lunabrush AIはFLUX-LLM技術のリーダーで、AI画像生成に特化",
  allRightsReserved: "Lunabrush AI. 全著作権所有",
  tools: "ツール",
  support: "サポート",
  imageGallery: "画像ギャラリー",
  termsOfService: "利用規約",
  privacyPolicy: "プライバシーポリシー",

  // Login Page
  welcomeTitle: "Lunabrush AIへようこそ",
  welcomeDesc: "ログイン方法を選択して素晴らしいAI画像の作成を開始",
  googleLogin: "Googleでログイン",
  githubLogin: "GitHubでログイン",
  loggingIn: "ログイン中...",
  loginTerms: "ログインすることで、当社の",
  and: "と",

  // Create Page
  createImage: "画像作成",
  createDesc: "Lunabrush AIで素晴らしい画像を作成",
  basic: "基本",
  advanced: "高度",
  prompt: "プロンプト",
  promptPlaceholder: "生成したい画像を説明してください...",
  model: "モデル",
  selectModel: "モデルを選択",
  negativePrompt: "ネガティブプロンプト",
  negativePromptPlaceholder: "画像に表示したくない内容...",
  aspectRatio: "アスペクト比",
  selectAspectRatio: "アスペクト比を選択",
  promptStrength: "プロンプト強度",
  highQualityGeneration: "高品質生成（時間がかかります）",
  preview: "プレビュー",
  imageWillAppear: "画像がここに表示されます",
  enterPrompt: "プロンプトを入力して生成ボタンをクリック",
  download: "ダウンロード",
  share: "共有",
  bookmark: "ブックマーク",

  // Gallery Page
  galleryTitle: "画像ギャラリー",
  galleryDesc: "Lunabrush AIが生成した素晴らしい画像を探索",
  searchPrompts: "プロンプトを検索...",
  sortBy: "並び替え",
  latest: "最新",
  popular: "人気",
  trending: "トレンド",
  style: "スタイル",
  allStyles: "すべてのスタイル",
  realistic: "リアル",
  anime: "アニメ",
  digitalArt: "デジタルアート",
  fantasy: "ファンタジー",
  loadMore: "もっと読み込む",

  // Pricing
  choosePlan: "プランを選択",
  pricingDesc: "Lunabrush AIプレミアムでより高速な生成速度と高度な機能を選択",
  monthly: "月額",
  yearly: "年額",
  saveTwoMonths: "2ヶ月節約",
  advanced: "アドバンス",
  personalUse: "個人利用に最適",
  unlimitedGeneration: "無制限画像生成",
  fastGeneration: "高速生成（5枚/分）",
  noAds: "広告なし",
  noWatermark: "透かしなし",
  upgradeToAdvanced: "アドバンスにアップグレード",
  ultimate: "アルティメット",
  mostPopular: "最も人気",
  professionalCreators: "プロのクリエイターに最適",
  ultraFastGeneration: "超高速生成",
  hdResolution: "高度なHD解像度",
  privateGeneration: "プライベート生成",
  advancedModels: "10以上の高度なモデルサポート",
  earlyAccess: "新機能への早期アクセス",
  upgradeToUltimate: "アルティメットにアップグレード",
  enterprise: "エンタープライズ",
  custom: "カスタム",
  teamsAndEnterprises: "チームと企業に最適",
  customSolutions: "カスタムソリューション",
  dedicatedSupport: "専用サポート",
  teamIntegration: "チームツール統合",
  highVolume: "大容量",
  contactUs: "お問い合わせ",

  // Style Options
  style: "スタイル",
  noStyle: "スタイルなし",
  digitalArt: "デジタルアート",
  cyberpunk: "サイバーパンク",
  lineArt: "線画",
  photography: "写真",
  film: "フィルム",
  origami: "折り紙",
  model3d: "3Dモデル",
  anime: "アニメ",
  fantasyArt: "ファンタジーアート",
  lowPoly: "ローポリ",
  cinematic: "映画的",
  enhanced: "強化",
  comicBook: "コミックブック",
  isometric: "アイソメトリック",
  clay: "クレイ",

  // Color Tone Options
  colorTone: "色調",
  noColor: "無彩色",
  warmTones: "暖色系",
  coolTones: "寒色系",
  softColors: "柔らかい色",
  vibrantColors: "鮮やかな色",
  pastelColors: "パステルカラー",
  blackAndWhite: "白黒",

  // Lighting Options
  lighting: "照明",
  noLighting: "照明なし",
  dramatic: "ドラマチック",
  dimLighting: "薄暗い照明",
  studio: "スタジオ",
  lowLight: "低照度",
  goldenHour: "ゴールデンアワー",
  backlight: "逆光",
  volumetricLight: "ボリューメトリックライト",
  tyndallEffect: "チンダル効果",
  sunlight: "日光",
  rimLight: "リムライト",

  // Composition Options
  composition: "構図",
  noComposition: "構図なし",
  blurredBackground: "ぼかした背景",
  closeUp: "クローズアップ",
  wideAngle: "広角",
  shallowDepthOfField: "浅い被写界深度",
  bottomUpShot: "下からのショット",
  topDownShot: "上からのショット",
  macroPhotography: "マクロ撮影",

  // 通用
  close: "閉じる",
} as const
